export default __webpack_public_path__ + "static/media/deliland-gpoil-icon.4f4bf0ae.png";